export default __webpack_public_path__ + "static/media/Calling Icon.ab017e25.svg";